import { NgClass } from "@angular/common";
import {
    Component,
    ChangeDetectionStrategy,
    Input,
    EventEmitter,
    Output,
    ChangeDetectorRef,
    ViewEncapsulation,
    signal,
    ViewChild,
    OnInit,
    computed,
} from "@angular/core";
import { Debounce } from "../../../../decorators/debounce.decorator";
import { EventService } from "../../../../services/event.service";
import { S25DatePatternModule } from "../../../s25-datepattern/s25.datepattern.module";
import { S25EditableModule } from "../../../s25-editable/s25.editable.module";
import { S25IconButtonComponent } from "../../../../standalone/s25.icon.button.component";
import { S25ItemComponent } from "../../../s25-item/s25.item.component";
import { S25ModalModule } from "../../../s25-modal/s25.modal.module";
import { S25ObjectSearchModule } from "../../../s25-object-search/s25.object.search.module";
import { PopoverComponent } from "../../../s25-popover/popover.component";
import { OccurrenceI } from "../../../../pojo/OccurrenceI";
import { S25ProfileUtil } from "../../utils/s25.profile.util";
import { S25EventOccurrencesService } from "../s25.event.occurrences.service";
import { S25Event } from "../../EventMicroI";
import { S25Util } from "../../../../util/s25-util";
import { S25Reservation, S25RmReservation, S25RsReservation } from "../../ReservationI";
import { S25ModalComponent } from "../../../s25-modal/s25.modal.component";
import { EvOccMappingComponent } from "../../../../standalone/ev-occ-mapping.component";
import { S25Profile, RecordType } from "../../ProfileI";
import { Flavor } from "../../../../pojo/Util";
import { S25DatePatternPickerComponent } from "../../../s25-datepattern/s25.datepattern.picker.component";
import { ReservationService } from "../../../../services/reservation.service";
import { ObjectSearchRefresh, S25ObjectSearchComponent } from "../../../s25-object-search/s25.object.search.component";
import { ObjectSearchAvail } from "../../../s25-object-search/object.search.avail";
import { Item } from "../../../../pojo/Item";
import { EventOccUtil } from "../s25-event-occurrence/s25.event.occurrence.util";
import { type Layout, S25ObjectSearchUtil } from "../../../s25-object-search/s25.object.search.util";
import { OccurrenceAdditionalDetailsComponent } from "../s25-event-occurrence/occ-table-components/occurrence-additional-details/occurrence.additional.details.component";

/**
 * Displays gear icon, lets the user select between 'seperated' and 'merged view'. migration of evdo-menu
 * OTHER NOTES:
 * Commented out "Delete This Segment"  event micro service current not support this feature
 * ACCL-1752 getting very large, don't want adding any new functionality
 *
 */
@Component({
    selector: "s25-ng-occ-menu",
    template: `
        <div class="occ-menu-wrapper" [class.single-profile]="!multiProfiles">
            @if (multiProfiles && ((isSeparatedView && isFirstSegment) || !isSeparatedView)) {
                <div class="occ-menu">
                    <button
                        class="view-select-button c-margin-right--half"
                        [ngClass]="{
                            'aw-button aw-button--primary': !isSeparatedView,
                            'c-textButton': isSeparatedView,
                        }"
                        (click)="onViewChange()"
                    >
                        Merged View
                    </button>
                    <button
                        class="view-select-button"
                        [ngClass]="{
                            'aw-button aw-button--primary': isSeparatedView,
                            'c-textButton': !isSeparatedView,
                        }"
                        (click)="onViewChange()"
                    >
                        Segment View
                    </button>
                </div>
            }

            @if (!multiProfiles) {
                <div class="view-select-button aw-button aw-button--primary aw-button-cursor-default">Segment View</div>
            }

            @if (canEdit) {
                @if (isSeparatedView || !multiProfiles) {
                    <button class="aw-button aw-button--outline" (click)="copySegment()">Copy This Segment</button>
                    <s25-ng-modal #occMappingModal [title]="'Copy Segment Occurrence Mapping'" [size]="'xl'">
                        <ng-template #s25ModalBody>
                            <s25-ng-occ-mapping
                                #occMappingComp
                                [startDate]="startDate"
                                [endDate]="endDate"
                                [rsrvs]="rsrvs"
                                [sourceProfileCode]="profileCode"
                                (modelValueChange)="onCopySegmentSubmit($event)"
                            />
                        </ng-template>
                    </s25-ng-modal>
                }
                <!-- add a new segment -->
                <button class="aw-button aw-button--outline" (click)="addSegment()">Add a New Segment</button>
                <s25-ng-modal #newSegmentFormModal [title]="'Add a New Segment'" [size]="'xl'">
                    <ng-template #s25ModalBody>
                        <div class="three-column-layout">
                            <div class="date-time-section" [ngClass]="{ 'modal-spaces': !addModalSpace() }">
                                @if (profileName()) {
                                    <s25-ng-editable-text
                                        class="segmentName"
                                        [allowEmpty]="false"
                                        [min]="2"
                                        [max]="40"
                                        [alwaysEditing]="true"
                                        [val]="profileName()"
                                        (valChange)="profileName.set($event)"
                                    ></s25-ng-editable-text>

                                    @if (!isCopySegment()) {
                                        <s25-ng-editable-start-end-datetime
                                            [startDatetime]="startDate"
                                            (startDatetimeChange)="onDateTimeChange($event, 'start')"
                                            [endDatetime]="endDate"
                                            (endDatetimeChange)="onDateTimeChange($event, 'end')"
                                            [noTimeUpdated]="true"
                                        >
                                        </s25-ng-editable-start-end-datetime>

                                        <div class="occ-menu-pattern">
                                            <s25-ng-date-pattern-picker
                                                #datePicker
                                                [timeModel]="{
                                                    evStartDt: startDate,
                                                    evEndDt: endDate,
                                                    minutes: {
                                                        setupMinutes: 0,
                                                        preMinutes: 0,
                                                        postMinutes: 0,
                                                        takedownMinutes: 0,
                                                    },
                                                }"
                                                [minDate]="endDate"
                                                [showAdHocList]="false"
                                                (apiBeanChange)="onDatePatternChange($event)"
                                            ></s25-ng-date-pattern-picker>
                                        </div>
                                    }

                                    <button
                                        class="aw-button aw-button--outline c-margin-top--half submit-button "
                                        [disabled]="savingNewProfile()"
                                        (click)="submitNewProfile()"
                                    >
                                        Submit
                                    </button>
                                }
                            </div>
                            <div class="add-locations">
                                <div>
                                    <button class="aw-button aw-button--outline" (click)="onObjectSearch(4)">
                                        Add Locations
                                    </button>
                                    <div class="c-margin-top--single">
                                        @for (location of locations[0]?.reserved; track location) {
                                            <s25-ng-icon-button
                                                [type]="'close'"
                                                [ariaLabel]="'Delete'"
                                                (clicked)="removedItem(4, location.itemId)"
                                            />
                                            <span class="c-margin-right--single"></span>
                                            <s25-item
                                                [itemId]="location.itemId"
                                                [itemTypeId]="Item.Ids.Location"
                                                [itemName]="location.itemName"
                                                [includeTypeIcon]="true"
                                            ></s25-item>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="add-resources">
                                <div>
                                    <button class="aw-button aw-button--outline" (click)="onObjectSearch(6)">
                                        Add Resources
                                    </button>
                                    <div class="c-margin-top--single">
                                        @for (resource of resources[0]?.reserved; track resource) {
                                            <s25-ng-icon-button
                                                [type]="'close'"
                                                [ariaLabel]="'Delete'"
                                                (clicked)="removedItem(6, resource.itemId)"
                                            />
                                            <span class="c-margin-right--single"></span>
                                            <s25-item
                                                [itemId]="resource.itemId"
                                                [itemTypeId]="Item.Ids.Resource"
                                                [itemName]="resource.itemName"
                                                [includeTypeIcon]="true"
                                            ></s25-item>

                                            <div class="res-qty">Quantity: {{ resource?.quantity }}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </s25-ng-modal>

                <s25-ng-modal
                    #objectSearchModal
                    class="object-search-modal"
                    [title]="itemTypeId === 4 ? 'Locations Search' : 'Resources Search'"
                    [size]="'xl'"
                >
                    <ng-template #s25ModalBody>
                        <s25-ng-object-search
                            #objectSearchComponent
                            [itemTypeId]="itemTypeId"
                            [occ]="newRsrvsData[0]"
                            [profileId]="newProfileId()"
                            [eventId]="eventId"
                            [selectedItems]="newRsrvsIds"
                            [event]="tempProfileEvent"
                            (refreshF)="onItemsChanges($event, itemTypeId)"
                            (cancelled)="objectSearchModal?.close()"
                        >
                        </s25-ng-object-search>
                    </ng-template>
                </s25-ng-modal>

                <button class="aw-button aw-button--outline" (click)="addOccurrence()">Add Occurrence</button>
                <s25-ng-modal #addOccModal [title]="'Add Occurrence'" [size]="'xl'">
                    <ng-template #s25ModalBody>
                        @if (newOcc) {
                            <occurrence-additional-details
                                [occ]="newOcc"
                                [mode]="'add'"
                                [canEdit]="true"
                                [editMode]="true"
                                [eventId]="eventId"
                                [profileId]="profileId"
                                (onCancel)="onAddOccCancel()"
                                (onSave)="onAddOccSave()"
                                (refreshF)="onAddOccRefresh()"
                            />
                        }
                    </ng-template>
                </s25-ng-modal>
            }

            @if (canEdit && isSeparatedView) {
                @if (multiProfiles) {
                    <button class="aw-button aw-button--danger--outline" (click)="deleteSegment()">
                        Delete This Segment
                    </button>
                }
            }
            @if (!multiProfiles || (isSeparatedView && isFirstSegment) || !isSeparatedView) {
                <button class="aw-button aw-button--outline" (click)="expandAllToggle()">
                    {{ isExpandAll ? "Collapse All" : "Expand All" }}
                </button>
            }
        </div>
    `,
    styles: [
        `
            .occ-menu-wrapper {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-block: 15px;
            }

            .occ-menu-wrapper.single-profile {
                margin-block: 1rem;
            }

            .occ-menu {
                font-size: 16px !important;
                font-weight: 600;
            }

            .nm-party--on {
                .occ-menu {
                    color: #fff;
                }

                .c-start-end-datetime-picker--wrapper {
                    box-shadow: unset !important;
                }
            }

            .view-select-button.aw-button.aw-button--primary {
                font-size: unset !important;
                border-radius: 7px;
            }

            .date-time-section {
                padding: 10px 20px 20px 20px;
                font-weight: normal !important;
                font-size: 15px;
                display: flex;
                flex-direction: column;
                gap: 10px; /* Space between elements inside the date-time section */
            }

            .date-time-section .occ-menu-pattern {
                display: flex;
                flex-direction: row;
                justify-content: left;
                padding: 20px 0px;
                font-size: 15px;

                s25-ng-date-pattern-picker label {
                    width: 100% !important;
                }

                s25-ng-date-pattern .repeats-every {
                    display: inline-block;
                }
            }

            .aw-button-cursor-default:hover {
                cursor: default !important;
                text-decoration: none !important;
            }

            .three-column-layout {
                display: flex;
                justify-content: space-between; /* Distribute the space between the columns */
                gap: 20px; /* Optional: Adjust space between columns */
            }

            .date-time-section,
            .add-locations,
            .add-resources {
                flex: 1; /* Each section will take equal width */
                min-width: 0; /* Prevents flex items from overflowing */
            }

            .add-locations,
            .add-resources {
                display: flex;
                align-items: flex-start;
                justify-content: left;
                padding: 10px;
                font-weight: normal !important;
                font-size: 15px;
                /* border: 1px solid #ccc; */ /* Optional: Add a border around the sections */
            }

            .submit-button {
                width: 80px;
            }

            :host ::ng-deep .s25-item-holder {
                display: flex;
                align-items: center;
            }

            .res-qty {
                font-size: 13px;
                margin-bottom: 10px;
                margin-left: 65px;
            }

            .modal-spaces {
                padding-bottom: 200px;
            }

            /* TODO: delete this after we add a way to mark modals as non-scrolling */
            .object-search-modal {
                .s25-modal--body {
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        S25ObjectSearchModule,
        S25ModalModule,
        S25ItemComponent,
        S25IconButtonComponent,
        S25DatePatternModule,
        S25EditableModule,
        NgClass,
        EvOccMappingComponent,
        S25ItemComponent,
        OccurrenceAdditionalDetailsComponent,
    ],
})
export class EvOccMenuComponent implements OnInit {
    @Input({ required: true }) isSeparatedView!: boolean;
    @Input() profileId?: number;
    @Input() canEdit?: boolean = false;
    @Input() multiProfiles?: boolean = false;
    @Input() startDate?: Date;
    @Input() endDate?: Date;
    @Input() isFirstSegment: boolean = false;
    @Input() eventId?: number;
    @Output() modelValueChange: EventEmitter<EvOccMenuOutput> = new EventEmitter<EvOccMenuOutput>();
    @ViewChild("occMappingComp") occMappingComp?: EvOccMappingComponent;
    @ViewChild("occMappingModal") occMappingModal?: S25ModalComponent;
    @ViewChild(PopoverComponent) popover!: PopoverComponent;
    @ViewChild("newSegmentFormModal") newSegmentFormModal?: S25ModalComponent;
    @ViewChild("datePicker") datePicker?: S25DatePatternPickerComponent;
    @ViewChild("objectSearchComponent") objSearchComp?: S25ObjectSearchComponent;
    @ViewChild("objectSearchModal") objectSearchModal?: S25ModalComponent;
    @ViewChild("addOccModal") addOccModal?: S25ModalComponent;

    init: boolean = false;
    readonly profileName = signal<string>("");
    readonly newProfileId = signal<number | null>(null);
    readonly isCopySegment = signal<boolean>(false);
    readonly savingNewProfile = signal(false);
    rsrvs: S25Reservation[] = [];
    isExpandAll: boolean = false;
    profileCode: string = "";
    pattern?: Flavor<string, "repeating pattern">;
    itemTypeId: number = Item.Ids.Location;
    newRsrvsData: S25Reservation[] = [];
    newProfileCode: string = "";
    newRsrvsIds: number[] = [];
    newProfileTemp: S25Profile | null = null;
    locations: S25RmReservation[] = [];
    resources: S25RsReservation[] = [];
    setup: number = 0;
    takedown: number = 0;
    tempProfileEvent?: S25Event;
    newOcc?: S25Reservation;

    protected readonly Item = Item;

    constructor(
        private cd: ChangeDetectorRef,
        private eventOccurrencesService: S25EventOccurrencesService,
    ) {}

    callerTags = computed(() => {
        return this.eventOccurrencesService.getCallerTags();
    });

    ngOnInit() {
        this.init = true;
        this.cd.detectChanges();
    }

    @Debounce(300) // Avoid double calls
    async copySegment() {
        const profile = S25ProfileUtil.getProfileByProfileId(
            this.eventOccurrencesService.getProfiles() as S25Profile[],
            this.profileId,
        ) as S25Profile;
        if (profile?.occurrenceDefn?.recTypeId === RecordType.RecurrenceGrammar)
            this.profileCode = profile?.occurrenceDefn?.profileCode ?? "";
        this.rsrvs = profile.reservations as S25Reservation[];
        this.isSeparatedView = true;
        this.isCopySegment.set(true);
        this.occMappingModal?.open();
    }

    //go to seperated view and indicate that a new segment is added
    async addSegment() {
        // reset temp profile , locations and resources  when open modal
        this.locations = [];
        this.resources = [];
        this.newProfileTemp = null;
        this.newProfileId.set(await EventService.getNewProfileId());
        this.profileName.set("Segment_" + this.newProfileId());
        this.isCopySegment.set(false);
        await this.newSegmentFormModal?.open();
        await this.getDatePickerData();
    }

    async addOccurrence() {
        if (!this.profileId) {
            return;
        }
        const profile = S25ProfileUtil.getProfileByProfileId(
            this.eventOccurrencesService.getProfiles() as S25Profile[],
            this.profileId,
        ) as S25Profile;
        this.newOcc = await EventOccUtil.createNewOcc(profile);
        await this.addOccModal?.open();
        this.cd.detectChanges();
    }

    onAddOccSave() {
        this.newOcc = undefined;
        this.addOccModal?.close();
        this.eventOccurrencesService.requestRefresh();
        this.cd.detectChanges();
    }

    onAddOccCancel() {
        this.newOcc = undefined;
        this.addOccModal?.close();
        this.cd.detectChanges();
    }

    onAddOccRefresh() {
        this.eventOccurrencesService.requestRefresh();
        this.cd.detectChanges();
    }

    async submitNewProfile() {
        if (this.savingNewProfile()) {
            return;
        }
        this.savingNewProfile.set(true);
        try {
            await this.saveNewProfile();
        } finally {
            this.savingNewProfile.set(false);
        }
    }

    private async saveNewProfile() {
        await this.getDatePickerData();
        const data: dataI = {
            startDate: this.startDate,
            endDate: this.endDate,
            profileName: this.profileName(),
            profileId: this.newProfileId(),
            isCopySegment: this.isCopySegment(),
            newProfileCode: this.newProfileCode,
            addNewOccs: this.newRsrvsData,
            newProfile: this.newProfileTemp,
        };
        this.isSeparatedView = true;
        if (this.newProfileTemp) this.newProfileTemp.itemName = this.profileName();
        if (this.newProfileTemp?.occurrenceDefn?.recTypeId === RecordType.RecurrenceGrammar) {
            this.newProfileTemp.occurrenceDefn.profileCode = this.newProfileCode;
        } else if (this.newProfileTemp?.occurrenceDefn?.recTypeId === RecordType.SingleDateTime) {
            this.newProfileTemp.occurrenceDefn.profileCode = EventOccUtil.setSingleProfieCode(this.startDate as Date);
        }

        if ((this.setup > 0 || this.takedown > 0) && this.newProfileTemp?.occurrenceDefn)
            this.newProfileTemp.occurrenceDefn.addedTime = {
                setup: S25Util.minutesToISODuration(this.setup),
                takedown: S25Util.minutesToISODuration(this.takedown),
            };

        this.modelValueChange.emit({ isSeparatedView: this.isSeparatedView, addNew: true, data: data });
        this.newSegmentFormModal?.close();
    }

    onCopySegmentSubmit(data: dataI) {
        (data.sourceProfileId = this.profileId), (data.isCopySegment = true);
        this.modelValueChange.emit({ isSeparatedView: this.isSeparatedView, addNew: true, data: data });
        this.occMappingModal?.close();
    }

    onDateTimeChange(newDate: Date, text: "start" | "end") {
        if (text === "start") {
            this.startDate = newDate;
            this.pattern && this.pattern !== "dnr" && this.datePicker?.changeFirstDt(newDate);
        } else {
            this.endDate = newDate;
        }
    }

    onViewChange() {
        const data = {
            profileId: this.profileId,
        };
        this.isSeparatedView = !this.isSeparatedView;
        this.modelValueChange.emit({ isSeparatedView: this.isSeparatedView, addNew: false, data: data });
    }

    @Debounce(300) // Avoid double calls
    deleteSegment() {
        this.isSeparatedView = true;
        this.modelValueChange.emit({
            isSeparatedView: this.isSeparatedView,
            addNew: false,
            data: { profileId: this.profileId },
            isDelete: true,
        });
    }

    refresh() {
        this.init = false;
        this.cd.detectChanges();
        this.init = true;
        this.cd.detectChanges();
    }

    expandAllToggle() {
        this.isExpandAll = !this.isExpandAll;
        this.eventOccurrencesService.setExpandAll(!this.isExpandAll);
        const elements: any = this.callerTags()
            ? document.querySelectorAll(this.callerTags())
            : document.querySelectorAll(this.isSeparatedView ? ".occ-expand-all" : ".occ-expand-all-segment");
        for (let i = 0; i < elements.length; ++i) {
            elements[i].click();
        }
        this.cd.detectChanges();
    }

    onDatePatternChange(apiBean: any) {
        this.pattern = apiBean.getProfileCode();
        this.cd.detectChanges();
    }

    async onItemsChanges(output: ObjectSearchRefresh, itemTypeId: Item.Ids) {
        //  add or update the reservation S25RmReservation||S25RsReservation[]
        const addOrUpdateReserved = (
            reservedArray: Array<S25RmReservation | S25RsReservation>,
            newItems: ReservationItem[],
        ): void => {
            if (reservedArray.length > 0) {
                reservedArray[0].reserved ??= [];
                reservedArray[0].reserved.push(...newItems);
            } else {
                reservedArray.push({ reserved: [...newItems], requested: [], draft: [] });
            }
        };

        if (itemTypeId === Item.Ids.Resource) {
            const res =
                output.items?.map((resource: ObjectSearchAvail.AddedResource) => ({
                    itemId: resource.resourceId,
                    itemName: resource.resourceName ?? "",
                    quantity: resource.quantity,
                })) ?? [];
            addOrUpdateReserved(this.resources, res);
        } else {
            const loc =
                output.items?.map((location: ObjectSearchAvail.AddedLocation) => ({
                    itemId: location.spaceId,
                    itemName: location.spaceName ?? "",
                    isShare: location.share,
                    layouts: location.layouts,
                })) ?? [];
            addOrUpdateReserved(this.locations, loc);
            if (this.locations.length > 0) {
                const { setup, takedown } = S25ObjectSearchUtil.maxLayoutTimes(
                    (this.locations[0].reserved ?? []) as ObjectSearchAvail.AddedLocation[],
                );
                this.setup = setup;
                this.takedown = takedown;
            }
        }

        await this.resetRsrv();
        this.objectSearchModal?.close();
    }

    async getDatePickerData() {
        this.newProfileCode = (await this.datePicker?.getProfileCode()) ?? "";
        const occs = (await this.datePicker?.getOccurrences()) ?? [];
        const recType = occs?.length === 1 ? 0 : this.newProfileCode === "adhoc" ? 2 : 1;
        if (["dnr", "adhoc"].includes(this.newProfileCode)) this.newProfileCode = "";
        const item = await ReservationService.generateReservationIds(occs.length);
        this.newRsrvsData = occs.map((occ, i) => {
            const start: Date = occ.evStartDt || (occ as any);
            const end: Date = occ.evEndDt || (occ as any);
            let eventStart = start;
            let eventEnd = end;
            if (recType === RecordType.AdHoc) {
                eventStart = S25Util.date.copyTime(new Date(start), this.startDate);
                eventEnd = S25Util.date.copyTime(new Date(end), this.endDate);
            }
            return {
                itemId: item?.idSet[i].rsrvId,
                state: 1,
                eventStart: eventStart,
                eventEnd: eventEnd,
                locations: this.locations,
                resources: this.resources,
                profileId: this.newProfileId(),
                profileName: this.profileName(),
                occurrence: S25Util.date.toS25ISODateStr(eventStart),
            } as S25Reservation;
        });
        await this.getProfileTemp(recType);
    }

    async onObjectSearch(id: Item.Ids) {
        await this.getDatePickerData();
        this.tempProfileEvent = this.buildTempProfileEvent();
        this.newRsrvsIds = S25Util.toItemIds(this.newRsrvsData);
        this.itemTypeId = id;
        this.objectSearchModal?.open();
    }

    /**
     * This is kinda jenky, but it creates a copy of the event with the new
     * profile inserted for searching purposes
     */
    private buildTempProfileEvent(): S25Event | undefined {
        const event = this.eventOccurrencesService.S25Event();
        if (!event) return undefined;
        if (!this.newProfileTemp) return event;
        const alreadyExists = event.profile?.some((p) => p.itemId === this.newProfileTemp!.itemId);
        if (alreadyExists) return event;
        return { ...event, profile: [...(event.profile ?? []), this.newProfileTemp] };
    }

    async getProfileTemp(recType: RecordType) {
        if (!this.newProfileTemp) {
            this.newProfileTemp = await S25ProfileUtil.createEmptyProfile(
                this.startDate,
                this.endDate,
                this.profileName(),
                this.newProfileId(),
                this.newProfileCode,
                recType,
            );
        } else {
            this.newProfileTemp.occurrenceDefn.recTypeId = recType;
            this.newProfileTemp.occurrenceDefn.initStartDt = S25Util.date.toS25ISODateTimeStr(this.startDate);
            this.newProfileTemp.occurrenceDefn.initEndDt = S25Util.date.toS25ISODateTimeStr(this.endDate);
        }

        if (!this.newProfileTemp) return;
        this.newProfileTemp.reservations = this.newRsrvsData;

        if (this.newProfileTemp.occurrenceDefn.recTypeId === RecordType.AdHoc) {
            const adHocDates = this.newRsrvsData.map((item) => S25Util.date.toS25ISODateStr(item.eventStart));
            this.newProfileTemp.occurrenceDefn.adHocDates = S25Util.array.uniqueDeep(adHocDates);
        }
    }

    async resetRsrv() {
        if (!this.newRsrvsData || !this.newProfileTemp) {
            return; // nothing to update
        }

        this.newRsrvsData.forEach((occ) => {
            occ.locations = this.locations ?? [];
            occ.resources = this.resources ?? [];
        });

        this.newProfileTemp.reservations = this.newRsrvsData;
    }

    async removedItem(itemTypeId: number, itemId: number) {
        if (itemTypeId === Item.Ids.Resource) {
            if (this.resources?.[0]?.reserved) {
                this.resources[0].reserved = this.resources[0].reserved.filter((item) => item.itemId !== itemId);
            }
        } else {
            if (this.locations?.[0]?.reserved) {
                this.locations[0].reserved = this.locations[0].reserved.filter((item) => item.itemId !== itemId);
            }
        }

        await this.resetRsrv();
        this.cd.detectChanges();
    }

    addModalSpace(): boolean {
        return this.pattern === undefined || this.pattern === "ndr" || this.pattern === "adhoc";
    }
}

export type EvOccMenuOutput = {
    isSeparatedView: boolean;
    data?: dataI;
    addNew: boolean;
    isDelete?: boolean;
};

export type dataI = {
    profileId?: number;
    profileName?: string;
    startDate?: Date;
    endDate?: Date;
    sourceProfileId?: number;
    mapping?: OccurrenceI.Mapping;
    isCopySegment?: boolean;
    newCopyRsrvsData?: S25Reservation[];
    newProfileCode?: string;
    addNewOccs?: S25Reservation[];
    newProfile?: S25Profile;
};

interface ReservationItem {
    itemId: number;
    itemName: string;
    quantity?: number;
    isShare?: boolean;
    layouts?: Layout[];
}
